import {Component, Injector, OnInit} from '@angular/core';
import {BaseNewComponents} from '../../shared/base-new-components';
import {ICardVideo} from '../../shared/interfaces/card-video.interface';
import { MESSAGES } from '../../core/constants/messages.constant';
import { ProdutoService as ProductService } from '../../core/services/produto.service';
import utils from '../../shared/utils';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent extends BaseNewComponents implements OnInit {

  public signatureInformations: ICardVideo[] = [
    {
      id: 1,
      icon: 'without-money',
      iconColor: '#EB2037',
      title: {
        label: 'Sem taxa de adesão ',
        bold: true,
      },
      subtitle: {
        label: ' ou complementos.',
        bold: false,
      },
      text: undefined
    },
    {
      id: 2,
      icon: 'calculate-money',
      iconColor: '#EB2037',
      title: {
        label: 'Planos de ',
        bold: false,
      },
      subtitle: {
        label: ' 7 diárias a partir de R$266,12.',
        bold: true,
      },
      text: undefined
    },
    {
      id: 3,
      icon: 'five-stars-hotel',
      iconColor: '#EB2037',
      title: {
        label: 'Flexibilidade para se hospedar ',
        bold: true,
      },
      subtitle: {
        label: ' em hotéis de outros planos.',
        bold: false,
      },
      text: undefined
    },
    {
      id: 4,
      icon: 'breakfast',
      iconColor: '#EB2037',
      title: {
        label: 'Café da manhã sempre incluso. ',
        bold: true,
      },
      subtitle: undefined,
      text: undefined
    },
    {
      id: 5,
      icon: 'calendar-time',
      iconColor: '#EB2037',
      title: {
        label: 'Reserve após a compra ou com ',
        bold: false,
      },
      subtitle: {
        label: '  6 meses de antecedência.',
        bold: true,
      },
      text: {
        label: '*(Mediante análise cadastral)',
        bold: false,
      }
    },
    {
      id: 6,
      icon: '24-month-calendar',
      iconColor: '#EB2037',
      title: {
        label: 'Até 24 meses para usar',
        bold: true,
      },
      subtitle: {
        label: ' as suas diárias.',
        bold: false,
      },
      text: undefined
    },
  ];
  public signatureInformationsSrcYoutube = 'https://www.youtube.com/embed/grd9tB8Tzbk?si=ikxrClCoaH8V8wGD';
  public signatureBackgroudImageVideo = './assets/img/view/new-video.png';
  public signatureInformationsTitle = 'O que é um clube de hospedagem?';
  public signatureInformationsSubtitle = `
            Um plano de hospedagem, para usar durante o ano,
            com milhares de hotéis disponíveis para ter as melhores experiências da sua vida.
            É a forma mais simples e moderna de programar as viagens com a família.
  `;
  public aboutUsSrcYoutube = 'https://www.youtube.com/embed/5g34sX-mwTo?si=3gfStYLAQaPogpmY';
  public aboutUsTitle = 'O que dizem sobre nós';
  public aboutUsBackgroundImageVideo = './assets/img/view/new-video2.png';
  public aboutUsBackgroundLinearGradient = '' +
      'linear-gradient(90deg, rgba(0, 0, 0, 0.50) 5.84%, rgba(0, 0, 0, 0.39) 54.06%, rgba(0, 0, 0, 0.00) 83.04%)';
  constructor(protected injector: Injector, protected productService: ProductService) {
    super(injector);
  }
  async ngOnInit() {
    super.ngOnInit();
    const {closedCart = false} = this.route.snapshot.queryParams;
    if (closedCart) {
      this.toast.error(MESSAGES.CLOSED_CART, '', {timeOut: 5000});
    }
    await this.loadPlansInformations();
  }

  async loadPlansInformations() {
    const result = await this.productService.plansInformations();
    if(!result) {
      return;
    }

    const plan = result.data.find((item) => item.title === 'COMPLETO');
    if(!plan) {
      return;
    }

    const price = plan.prices.find((item) => item.daily === 4 && item.people === 2);
    if(!price) {
      return;
    }

    this.signatureInformations = this.signatureInformations.map((item) => {
        if(item.id === 2) {
          const value = utils.convertPrice(price.price);
            item.subtitle.label = `Plano de ${price.daily} diárias a partir de R$${value}`;
        }
        return item;
    });
  }
}
